import { fetchGet } from '../../../store/fetch';
import { IFailureMode } from '../Interfaces/IFailureMode';

export async function getUnitFailureModesToCopy(surveyId: string, elementId: string, unitId: string, manifestationFailureModes: IFailureMode[]) {
    const url = `/api/surveys/${surveyId}/failureModes`;
    const result = await fetchGet(url, {
        elementId,
        unitId,
        manifestationId: 'null',
    });
    const failureModesToCopy = result.json.filter(
        (unitFailureMode: { id: string }) =>
            manifestationFailureModes.find((manifestationFailureMode) => manifestationFailureMode.copyOfFailureModeId === unitFailureMode.id) ===
            undefined,
    );
    return failureModesToCopy;
}
